import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

const Footer = () => {
  return (
    <footer className="bg-[#3d5c28] text-white mt-10 w-full">
      <div className="w-full px-6 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-[#8BC34A]">Siri Farms</h3>
            <p className="text-sm text-gray-200 leading-relaxed">
              Bringing fresh, local tropical produce to families across the USA
            </p>
            {/* Social Media Links - Disabled */}
            <div className="flex space-x-3 pt-2">
              <span
                className="w-10 h-10 bg-gray-500 rounded-full flex items-center justify-center cursor-not-allowed opacity-50"
                title="Coming Soon"
              >
                <FacebookIcon className="text-white" fontSize="small" />
              </span>
              <span
                className="w-10 h-10 bg-gray-500 rounded-full flex items-center justify-center cursor-not-allowed opacity-50"
                title="Coming Soon"
              >
                <InstagramIcon className="text-white" fontSize="small" />
              </span>
              <span
                className="w-10 h-10 bg-gray-500 rounded-full flex items-center justify-center cursor-not-allowed opacity-50"
                title="Coming Soon"
              >
                <TwitterIcon className="text-white" fontSize="small" />
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-200 hover:text-[#8BC34A] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-200 hover:text-[#8BC34A] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-200 hover:text-[#8BC34A] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-200 hover:text-[#8BC34A] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-condition" className="text-sm text-gray-200 hover:text-[#8BC34A] transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright - Updated to 2026 */}
        <div className="max-w-7xl mx-auto border-t border-[#4a6b30] mt-10 pt-6">
          <p className="text-center text-sm text-gray-300">
            © 2026 Siri Farms. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
